"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMainnetEquivalent = exports.getAssetEntryFromChaindata = exports.getDecimalsForAsset = exports.getOnchainBalance = void 0;
const ethers_1 = require("ethers");
const __1 = require("..");
const getOnchainBalance = async (assetId, address, provider) => {
    return assetId === ethers_1.constants.AddressZero
        ? (0, __1.getETHBalance)(provider, address)
        : (0, __1.getTokenBalance)(assetId, address, provider);
};
exports.getOnchainBalance = getOnchainBalance;
const getDecimalsForAsset = async (assetId, chainId, provider, chainData, decimalsCallback = () => Promise.resolve(18)) => {
    if (chainData) {
        const domainId = (0, __1.chainIdToDomain)(chainId);
        const assetRecord = (0, exports.getAssetEntryFromChaindata)(assetId, domainId, chainData);
        const decimals = assetRecord?.decimals;
        if (decimals) {
            return decimals;
        }
    }
    if (assetId === ethers_1.constants.AddressZero) {
        return 18;
    }
    if (provider) {
        return await (0, __1.getTokenDecimals)(assetId, provider);
    }
    return await decimalsCallback();
};
exports.getDecimalsForAsset = getDecimalsForAsset;
const getAssetEntryFromChaindata = (assetId, domainId, chainData) => {
    let checksummedAssetId = assetId;
    try {
        checksummedAssetId = ethers_1.utils.getAddress(assetId);
    }
    catch (e) {
        // NOTE: this could fail, i.e. if the asset starts with "0X" or is an invalid address
    }
    const chainInfo = chainData.get(domainId.toString());
    const assetRecord = chainInfo
        ? chainInfo.assetId[assetId] ??
            chainInfo.assetId[checksummedAssetId] ??
            chainInfo.assetId[assetId.toLowerCase()] ??
            chainInfo.assetId[assetId.toUpperCase()]
        : undefined;
    return assetRecord;
};
exports.getAssetEntryFromChaindata = getAssetEntryFromChaindata;
const getMainnetEquivalent = async (chainId, assetId, _chainData) => {
    const chainData = _chainData ?? (await (0, __1.getChainData)());
    const domainId = (0, __1.chainIdToDomain)(chainId);
    const record = (0, exports.getAssetEntryFromChaindata)(assetId, domainId, chainData);
    if (!record || !record.mainnetEquivalent) {
        return undefined;
    }
    return ethers_1.utils.getAddress(record.mainnetEquivalent);
};
exports.getMainnetEquivalent = getMainnetEquivalent;
//# sourceMappingURL=asset.js.map